import React from 'react';
import './AMC.css';

const features = [
  { icon: 'bi-person-gear', text: 'Company-trained service engineers on call' },
  { icon: 'bi-box2-heart', text: 'Genuine spare parts with reliable lead times' },
  { icon: 'bi-shield-fill-check', text: 'Zero downtime commitment for your machines' },
  { icon: 'bi-currency-rupee', text: 'Competitive and fully customised AMC plans' },
  { icon: 'bi-list-check', text: 'Covers Dehumidifiers, AHUs & Plastic Auxiliary Machines' },
];

const machines = [
  { icon: 'bi-moisture', name: 'Dehumidifier' },
  { icon: 'bi-wind', name: 'AHU' },
  { icon: 'bi-gear', name: 'Plastic Auxiliary Machines' },
];

function AMC() {
  return (
    <section className="amc-section" id="amc">
      <div className="container">
        <div className="text-center mb-5">
          <div className="section-eyebrow">Maintenance Plans</div>
          <h2 className="section-title">Annual Maintenance Contract</h2>
          <p className="section-sub mx-auto" style={{ maxWidth: '520px' }}>
            Company-trained engineers and genuine spare parts —
            delivering the zero downtime your operations depend on.
          </p>
        </div>

        <div className="row g-4 align-items-stretch">

          {/* Features list */}
          <div className="col-lg-6">
            <div className="amc-features-box">
              <h5 className="amc-box-heading">
                <i className="bi bi-check2-circle me-2"></i>What's Included
              </h5>
              {features.map((f, i) => (
                <div className="amc-feature-row" key={i}>
                  <div className="amc-feature-icon">
                    <i className={`bi ${f.icon}`}></i>
                  </div>
                  <span>{f.text}</span>
                </div>
              ))}

              <div className="amc-machines mt-4">
                <p className="amc-machines-label">Machines Covered</p>
                <div className="d-flex gap-3 flex-wrap">
                  {machines.map((m, i) => (
                    <div className="amc-machine-pill" key={i}>
                      <i className={`bi ${m.icon} me-2`}></i>{m.name}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* CTA box */}
          <div className="col-lg-6">
            <div className="amc-cta-box">
              <div className="amc-shield-icon">
                <i className="bi bi-shield-check"></i>
              </div>
              <h3 className="amc-cta-title">Zero Downtime Guarantee</h3>
              <p className="amc-cta-desc">
                Our AMC plans are tailored to keep your critical equipment running at
                peak performance year-round. With trained engineers and spare parts
                on standby, trust ATS to protect your investment and your productivity.
              </p>
              <div className="amc-badges">
                <div className="amc-badge"><i className="bi bi-lightning-charge me-1"></i>Fast Response</div>
                <div className="amc-badge"><i className="bi bi-tools me-1"></i>Expert Engineers</div>
                <div className="amc-badge"><i className="bi bi-graph-up me-1"></i>Max Uptime</div>
              </div>
              <a
                href="#contact"
                className="btn-ats-primary mt-4 d-inline-block"
                onClick={e => { e.preventDefault(); document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' }); }}
              >
                <i className="bi bi-clipboard-check me-2"></i>Get an AMC Plan
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default AMC;
